export default {
  org: {
    age: 'Age',
    ageRange: 'Age range',
    allGenders: 'All Genders',
    allStudies: 'All studies',
    cities: 'Cities',
    conditions: 'Conditions',
    distance: 'Distance',
    fakeSite: 'Fake site',
    filterHasBeenAdded: 'Filter has been added',
    gender: 'Gender',
    healthCondition: 'Health condition',
    imLookingForResearchAbout: "I'm looking for research about",
    medicalConditions: 'Medical conditions',
    milesAway: 'Miles away',
    newsSearch: 'News search',
    noFiltersAvailableForThisSelection: 'No filters available for this selection',
    openTo: 'Open to',
    readStudyDetails: 'Read study details',
    recruiting: 'Recruiting',
    results: 'Results',
    showResults: 'Show results',
    study: 'Study',
    studyIsAvailable: 'Study is available',
    studyResultsListedBelow: 'Study results listed below',
    studyStatus: 'Study status',
    towns: 'Towns',
    trialsDetails: 'Trials details',
    whereCanITakePartIn: 'Where can I take part in',
    whereThe: 'Where the',
    xStudiesFound: '{x} studies found',
    xStudiesFoundForY: '{x} studies found for {y}',
  },
}
